module.exports = __webpack_public_path__ + "media/images/dummys/blue-b51e3f015cfb41335235a756f941a03c.jpg";